"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[7387],{

/***/ 29254:
/***/ (function(__unused_webpack_module, __unused_webpack_exports, __webpack_require__) {


var $ = __webpack_require__(82109);
var createHTML = __webpack_require__(14230);
var forcedStringHTMLMethod = __webpack_require__(43429);

// `String.prototype.link` method
// https://tc39.es/ecma262/#sec-string.prototype.link
$({ target: 'String', proto: true, forced: forcedStringHTMLMethod('link') }, {
  link: function link(url) {
    return createHTML(this, 'a', 'href', url);
  }
});


/***/ }),

/***/ 6967:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "X": function() { return /* binding */ Row; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(26042);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var _Box__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(46523);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);




var Row = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.forwardRef)(function(props, ref) {
    return /* @__PURE__ */ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Box__WEBPACK_IMPORTED_MODULE_2__/* .Box */ .x, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        ref: ref,
        flexDirection: "row"
    }, props));
});



/***/ }),

/***/ 47208:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {

/* unused harmony export Link */
/* harmony import */ var core_js_modules_es_symbol_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(82526);
/* harmony import */ var core_js_modules_es_symbol_description_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(41817);
/* harmony import */ var core_js_modules_es_symbol_iterator_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(32165);
/* harmony import */ var core_js_modules_es_symbol_to_primitive_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96649);
/* harmony import */ var core_js_modules_es_array_filter_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(57327);
/* harmony import */ var core_js_modules_es_array_for_each_js__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(89554);
/* harmony import */ var core_js_modules_es_array_index_of_js__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(82772);
/* harmony import */ var core_js_modules_es_array_iterator_js__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(66992);
/* harmony import */ var core_js_modules_es_date_to_primitive_js__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(96078);
/* harmony import */ var core_js_modules_es_number_constructor_js__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(9653);
/* harmony import */ var core_js_modules_es_object_assign_js__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19601);
/* harmony import */ var core_js_modules_es_object_define_properties_js__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(33321);
/* harmony import */ var core_js_modules_es_object_define_property_js__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(69070);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptor_js__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(38880);
/* harmony import */ var core_js_modules_es_object_get_own_property_descriptors_js__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(49337);
/* harmony import */ var core_js_modules_es_object_keys_js__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(47941);
/* harmony import */ var core_js_modules_es_object_to_string_js__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(41539);
/* harmony import */ var core_js_modules_es_string_iterator_js__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(78783);
/* harmony import */ var core_js_modules_web_dom_collections_for_each_js__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(54747);
/* harmony import */ var core_js_modules_web_dom_collections_iterator_js__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(33948);
/* harmony import */ var core_js_modules_es_string_link_js__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(29254);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(67294);
/* harmony import */ var _chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_25__ = __webpack_require__(97375);
/* harmony import */ var _chakra_ui_system__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(24614);
/* harmony import */ var _hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_24__ = __webpack_require__(79652);
/* harmony import */ var _system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_26__ = __webpack_require__(26153);
/* harmony import */ var _system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_23__ = __webpack_require__(48189);
/* harmony import */ var _Flex_index_mjs__WEBPACK_IMPORTED_MODULE_27__ = __webpack_require__(93298);
/* harmony import */ var _Icon_index_mjs__WEBPACK_IMPORTED_MODULE_28__ = __webpack_require__(49154);
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }




















var _excluded = ["analyticsName", "trackImpression", "onClick", "leftIcon", "rightIcon", "disabled", "href", "children"];
function cov_10uyfywcnq() {
  var path = "/__w/code/code/js/packages/bricks/src/core/Link/Link.tsx";
  var hash = "624d8474d97852b7945b5760b09a6cb954b8ba19";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/__w/code/code/js/packages/bricks/src/core/Link/Link.tsx",
    statementMap: {
      "0": {
        start: {
          line: 167,
          column: 20
        },
        end: {
          line: 247,
          column: 1
        }
      },
      "1": {
        start: {
          line: 182,
          column: 21
        },
        end: {
          line: 182,
          column: 95
        }
      },
      "2": {
        start: {
          line: 183,
          column: 19
        },
        end: {
          line: 186,
          column: 6
        }
      },
      "3": {
        start: {
          line: 187,
          column: 34
        },
        end: {
          line: 187,
          column: 56
        }
      },
      "4": {
        start: {
          line: 188,
          column: 22
        },
        end: {
          line: 188,
          column: 94
        }
      },
      "5": {
        start: {
          line: 189,
          column: 23
        },
        end: {
          line: 189,
          column: 51
        }
      },
      "6": {
        start: {
          line: 191,
          column: 24
        },
        end: {
          line: 203,
          column: 5
        }
      },
      "7": {
        start: {
          line: 193,
          column: 8
        },
        end: {
          line: 195,
          column: 9
        }
      },
      "8": {
        start: {
          line: 194,
          column: 10
        },
        end: {
          line: 194,
          column: 89
        }
      },
      "9": {
        start: {
          line: 197,
          column: 8
        },
        end: {
          line: 199,
          column: 9
        }
      },
      "10": {
        start: {
          line: 198,
          column: 10
        },
        end: {
          line: 198,
          column: 21
        }
      },
      "11": {
        start: {
          line: 205,
          column: 42
        },
        end: {
          line: 217,
          column: 5
        }
      },
      "12": {
        start: {
          line: 219,
          column: 42
        },
        end: {
          line: 223,
          column: 5
        }
      },
      "13": {
        start: {
          line: 225,
          column: 4
        },
        end: {
          line: 239,
          column: 5
        }
      },
      "14": {
        start: {
          line: 226,
          column: 6
        },
        end: {
          line: 238,
          column: 8
        }
      },
      "15": {
        start: {
          line: 241,
          column: 4
        },
        end: {
          line: 245,
          column: 6
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 168,
            column: 2
          },
          end: {
            line: 168,
            column: 3
          }
        },
        loc: {
          start: {
            line: 181,
            column: 7
          },
          end: {
            line: 246,
            column: 3
          }
        },
        line: 181
      },
      "1": {
        name: "(anonymous_1)",
        decl: {
          start: {
            line: 192,
            column: 6
          },
          end: {
            line: 192,
            column: 7
          }
        },
        loc: {
          start: {
            line: 192,
            column: 13
          },
          end: {
            line: 200,
            column: 7
          }
        },
        line: 192
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 182,
            column: 21
          },
          end: {
            line: 182,
            column: 95
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 182,
            column: 21
          },
          end: {
            line: 182,
            column: 55
          }
        }, {
          start: {
            line: 182,
            column: 59
          },
          end: {
            line: 182,
            column: 95
          }
        }],
        line: 182
      },
      "1": {
        loc: {
          start: {
            line: 193,
            column: 8
          },
          end: {
            line: 195,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 193,
            column: 8
          },
          end: {
            line: 195,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 193
      },
      "2": {
        loc: {
          start: {
            line: 197,
            column: 8
          },
          end: {
            line: 199,
            column: 9
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 197,
            column: 8
          },
          end: {
            line: 199,
            column: 9
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 197
      },
      "3": {
        loc: {
          start: {
            line: 197,
            column: 12
          },
          end: {
            line: 197,
            column: 32
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 197,
            column: 12
          },
          end: {
            line: 197,
            column: 19
          }
        }, {
          start: {
            line: 197,
            column: 23
          },
          end: {
            line: 197,
            column: 32
          }
        }],
        line: 197
      },
      "4": {
        loc: {
          start: {
            line: 212,
            column: 12
          },
          end: {
            line: 212,
            column: 40
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 212,
            column: 23
          },
          end: {
            line: 212,
            column: 31
          }
        }, {
          start: {
            line: 212,
            column: 34
          },
          end: {
            line: 212,
            column: 40
          }
        }],
        line: 212
      },
      "5": {
        loc: {
          start: {
            line: 215,
            column: 12
          },
          end: {
            line: 215,
            column: 39
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 215,
            column: 23
          },
          end: {
            line: 215,
            column: 32
          }
        }, {
          start: {
            line: 215,
            column: 35
          },
          end: {
            line: 215,
            column: 39
          }
        }],
        line: 215
      },
      "6": {
        loc: {
          start: {
            line: 221,
            column: 13
          },
          end: {
            line: 221,
            column: 73
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 221,
            column: 13
          },
          end: {
            line: 221,
            column: 28
          }
        }, {
          start: {
            line: 221,
            column: 33
          },
          end: {
            line: 221,
            column: 72
          }
        }],
        line: 221
      },
      "7": {
        loc: {
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 239,
            column: 5
          }
        },
        type: "if",
        locations: [{
          start: {
            line: 225,
            column: 4
          },
          end: {
            line: 239,
            column: 5
          }
        }, {
          start: {
            line: undefined,
            column: undefined
          },
          end: {
            line: undefined,
            column: undefined
          }
        }],
        line: 225
      },
      "8": {
        loc: {
          start: {
            line: 229,
            column: 13
          },
          end: {
            line: 229,
            column: 62
          }
        },
        type: "binary-expr",
        locations: [{
          start: {
            line: 229,
            column: 13
          },
          end: {
            line: 229,
            column: 21
          }
        }, {
          start: {
            line: 229,
            column: 25
          },
          end: {
            line: 229,
            column: 62
          }
        }],
        line: 229
      },
      "9": {
        loc: {
          start: {
            line: 232,
            column: 11
          },
          end: {
            line: 236,
            column: 11
          }
        },
        type: "cond-expr",
        locations: [{
          start: {
            line: 233,
            column: 12
          },
          end: {
            line: 233,
            column: 50
          }
        }, {
          start: {
            line: 235,
            column: 12
          },
          end: {
            line: 235,
            column: 56
          }
        }],
        line: 232
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0,
      "10": 0,
      "11": 0,
      "12": 0,
      "13": 0,
      "14": 0,
      "15": 0
    },
    f: {
      "0": 0,
      "1": 0
    },
    b: {
      "0": [0, 0],
      "1": [0, 0],
      "2": [0, 0],
      "3": [0, 0],
      "4": [0, 0],
      "5": [0, 0],
      "6": [0, 0],
      "7": [0, 0],
      "8": [0, 0],
      "9": [0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "624d8474d97852b7945b5760b09a6cb954b8ba19"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_10uyfywcnq = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_10uyfywcnq();
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }








/**
 * Text buttons are typically used for less-pronounced actions.
 * Link variant variations
 * ------------------------------------------------------------------------------------------------
 *
 * "inline-primary"
 *
 * "inline-secondary"
 *
 * "primary-button"
 *
 * "secondary-button"
 *
 * Link size variations
 * ---------------------------------------------------------------------------------------------
 *
 * "sm"
 *
 * "md"
 *
 * "lg"
 *
 * Accessibility
 *
 *
 * -----------------
 *
 * Screen readers handle links slightly differently than they do buttons. All
 * links and buttons are tab-able, but pressing the Space key or Enter
 * triggers a button, whereas pressing the Enter key only triggers a link.
 *
 * **The simplest rule of thumb is to just use the right HTML elements for the
 * content. Realistically, this is not possible 100% of the time—just
 * remember, when using the wrong elements keep in mind there are behaviors
 * and states that may be expected that will need to be accounted for.**
 *
 * Please keep in mind that the functional links that look like button
 * variants (`primary-button` & `secondary-button`) are antipatterns. However
 * for conversion reasons this is occasionally a requirement. Make sure to
 * verify with Design that this behavior is absolutely necessary and
 * appropriate a11y concerns were considered.
 *
 * ###
 *
 * Impact:
 *
 * ####
 *
 * Tab order
 *
 * `<a>` elements without an href attribute are NOT in the tab order.
 * Elements typically not in the tab order can be added by setting the
 * tabindex attribute to 0 on that element.
 *
 * ####
 *
 * Hover and focus states
 *
 * Unlike button and input elements, `<a>` do NOT by default trigger the
 * associated click event on keypress of the `SPACE` keys without additional
 * work.
 *
 * ####
 *
 * Assistive technologies
 *
 * While `<a>` elements are treated uniquely, it's common to identify all
 * links on a page using assistive technologies to more easily navigate
 * throughout a site. Therefore, it might be strange having those intended to
 * be used as a button to be mixed up with the other actual links. Any element
 * intended to be a button not marked up using button or input can have the
 * ARIA role attribute set to button—keep in mind, though, all the
 * behaviors/states above still need to be implemented.
 *
 * If you need to have a functional button that looks like a link, use a
 * `<Button />` component with a link variant:
 *
 * ####
 *
 * ✅ Pass
 *
 * <Button onClick={() => { /* function that does something other than
 * navigation *&#47; }} variant="link" aria-label={null} > Click me!!!
 * </Button>
 *
 *
 * ####
 *
 * 🛑 Fail
 *
 * <Link onClick={() => { /* function that does something other than
 * navigation *&#47; }} href="" aria-label={null} > Click me!!!  </Link>
 *
 *
 * ###
 *
 * Further Reading
 *
 * [Buttons & Links | Accessibility
 * Guidelines](http://web-accessibility.carnegiemuseums.org/content/buttons/)
 * [Proper Use of Buttons and
 * Links](https://www.webaxe.org/proper-use-buttons-links/)  [Links, Buttons,
 * Submits, and Divs, Oh
 * Hell](https://adrianroselli.com/2016/01/links-buttons-submits-and-divs-oh-hell.html)
 * [When To Use The Button Element |
 * CSS-Tricks](https://css-tricks.com/use-button-element/) [The Anchor Button:
 * Bad for Accessibility, Bad for
 * Usability](http://itstiredinhere.blogspot.com/2014/08/the-anchor-button-bad-for-accessibility.html?m=1)
 *
 * Analytics
 *
 *
 * -------------
 *
 * `Link` is set up to track click and impression events:
 *
 * *   To track click events pass in an non-empty `analyticsName` (convention:
 * {appName}-{linkName})
 *
 * *   To track impression events pass: 1) a non-empty `analyticsName` 2) pass
 * `trackImpression={true}`
 *
 *
 * Link impression events will only be tracked the first time that the link
 * enters the viewport
 *
 * Events will be sent to the journey service and will end up in the
 * corresponding tables (e.g.
 * journey\_service\_production.platform\_link\_view\_event for link
 * impression events). For more information on tracking please refer
 * here:[https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update](https://opendoor.atlassian.net/wiki/spaces/CONSUMER/blog/2023/05/10/2304737293/Bricks+Events+Update)
 */
var Link = (cov_10uyfywcnq().s[0]++, (0,_chakra_ui_system__WEBPACK_IMPORTED_MODULE_22__/* .forwardRef */ .Gp)(function (_ref, ref) {
  var analyticsName = _ref.analyticsName,
    trackImpression = _ref.trackImpression,
    onClick = _ref.onClick,
    leftIcon = _ref.leftIcon,
    rightIcon = _ref.rightIcon,
    disabled = _ref.disabled,
    href = _ref.href,
    children = _ref.children,
    props = _objectWithoutProperties(_ref, _excluded);
  cov_10uyfywcnq().f[0]++;
  var isButton = (cov_10uyfywcnq().s[1]++, (cov_10uyfywcnq().b[0][0]++, props.variant === 'primary-button') || (cov_10uyfywcnq().b[0][1]++, props.variant === 'secondary-button'));
  var styles = (cov_10uyfywcnq().s[2]++, (0,_system_utils_index_mjs__WEBPACK_IMPORTED_MODULE_23__/* .useMultiStyleConfig */ .jC)('Link', _objectSpread(_objectSpread({}, props), {}, {
    disabled: disabled
  })));
  var _ref2 = (cov_10uyfywcnq().s[3]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_24__/* .useObservabilitySafe */ .r)()),
    trackJourneyEvent = _ref2.trackJourneyEvent;
  var inViewRef = (cov_10uyfywcnq().s[4]++, (0,_hooks_useObservabilitySafe_mjs__WEBPACK_IMPORTED_MODULE_24__/* .useTrackComponentInView */ .O)('linkViewEvent', trackImpression, analyticsName));
  var mergedRefs = (cov_10uyfywcnq().s[5]++, (0,_chakra_ui_hooks__WEBPACK_IMPORTED_MODULE_25__/* .useMergeRefs */ .qq)(inViewRef, ref));
  var handleClick = (cov_10uyfywcnq().s[6]++, (0,react__WEBPACK_IMPORTED_MODULE_21__.useCallback)(function (e) {
    cov_10uyfywcnq().f[1]++;
    cov_10uyfywcnq().s[7]++;
    if (analyticsName) {
      cov_10uyfywcnq().b[1][0]++;
      cov_10uyfywcnq().s[8]++;
      trackJourneyEvent('platform', 'linkClickEvent', {
        targetName: analyticsName
      });
    } else {
      cov_10uyfywcnq().b[1][1]++;
    }
    cov_10uyfywcnq().s[9]++;
    if ((cov_10uyfywcnq().b[3][0]++, onClick) && (cov_10uyfywcnq().b[3][1]++, !disabled)) {
      cov_10uyfywcnq().b[2][0]++;
      cov_10uyfywcnq().s[10]++;
      onClick(e);
    } else {
      cov_10uyfywcnq().b[2][1]++;
    }
  },
  // eslint-disable-next-line react-hooks/exhaustive-deps
  [analyticsName, onClick, disabled]));
  var linkProps = (cov_10uyfywcnq().s[11]++, _objectSpread({
    /*
     * NOTE: Forcing links to function as buttons to ensure that a11y is handled correctly
     * This is a known antipattern, however for conversion reasons this is occasionally a
     * requirement. Make sure to verify with design that this behavior is absolutely necessary
     * and appropriate a11y concerns were considered.
     */
    role: isButton ? (cov_10uyfywcnq().b[4][0]++, 'button') : (cov_10uyfywcnq().b[4][1]++, 'link'),
    __css: styles.link,
    onClick: handleClick,
    href: disabled ? (cov_10uyfywcnq().b[5][0]++, undefined) : (cov_10uyfywcnq().b[5][1]++, href)
  }, props));
  var iconProps = (cov_10uyfywcnq().s[12]++, {
    __css: styles.icon,
    color: (cov_10uyfywcnq().b[6][0]++, linkProps.color) || (cov_10uyfywcnq().b[6][1]++, styles.link.color),
    size: 16
  });
  cov_10uyfywcnq().s[13]++;
  if (props.variant === 'nav') {
    cov_10uyfywcnq().b[7][0]++;
    cov_10uyfywcnq().s[14]++;
    return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_26__/* .bricks.a */ .G.a, _extends({
      ref: mergedRefs
    }, linkProps), /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_Flex_index_mjs__WEBPACK_IMPORTED_MODULE_27__/* ["default"] */ .Z, {
      __css: styles.content
    }, (cov_10uyfywcnq().b[8][0]++, leftIcon) && (cov_10uyfywcnq().b[8][1]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_Icon_index_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, _extends({}, iconProps, leftIcon))), children), rightIcon ? (cov_10uyfywcnq().b[9][0]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_Icon_index_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, _extends({}, iconProps, rightIcon))) : (cov_10uyfywcnq().b[9][1]++, /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_Icon_index_mjs__WEBPACK_IMPORTED_MODULE_28__/* ["default"] */ .Z, _extends({}, iconProps, {
      name: "chevron-right"
    }))));
  } else {
    cov_10uyfywcnq().b[7][1]++;
  }
  cov_10uyfywcnq().s[15]++;
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_21__.createElement(_system_bricks_types_mjs__WEBPACK_IMPORTED_MODULE_26__/* .bricks.a */ .G.a, _extends({
    ref: mergedRefs
  }, linkProps), children);
}));
/* harmony default export */ __webpack_exports__["Z"] = (Link);

/***/ }),

/***/ 33733:
/***/ (function(__unused_webpack___webpack_module__, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ createReactComponent; }
});

// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/defaultAttributes.mjs
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

var defaultAttributes = {
  outline: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  },
  filled: {
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "currentColor",
    stroke: "none"
  }
};


//# sourceMappingURL=defaultAttributes.mjs.map

;// CONCATENATED MODULE: ./node_modules/@tabler/icons-react/dist/esm/createReactComponent.mjs
/**
 * @license @tabler/icons-react v3.36.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */




const createReactComponent = (type, iconName, iconNamePascal, iconNode) => {
  const Component = (0,react.forwardRef)(
    ({ color = "currentColor", size = 24, stroke = 2, title, className, children, ...rest }, ref) => (0,react.createElement)(
      "svg",
      {
        ref,
        ...defaultAttributes[type],
        width: size,
        height: size,
        className: [`tabler-icon`, `tabler-icon-${iconName}`, className].join(" "),
        ...type === "filled" ? {
          fill: color
        } : {
          strokeWidth: stroke,
          stroke: color
        },
        ...rest
      },
      [
        title && (0,react.createElement)("title", { key: "svg-title" }, title),
        ...iconNode.map(([tag, attrs]) => (0,react.createElement)(tag, attrs)),
        ...Array.isArray(children) ? children : [children]
      ]
    )
  );
  Component.displayName = `${iconNamePascal}`;
  return Component;
};


//# sourceMappingURL=createReactComponent.mjs.map


/***/ })

}]);